import {
	Component,
	Input,
	OnInit
}                                          from '@angular/core';
import { BaseComponent }                   from '@core/bases/base-component/base.component';
import { IEntityActiveSortPropertyConfig } from '@shared/components/entity-active-sort-property/entity-active-sort-property.model';
import {
	ListOperations,
	ListOperationsIdentifierEnum
}                                          from '@shared/list-operations/model/list-operations.model';
import { ListOperationsService }           from '@shared/list-operations/services/list-operations.service';
import { Subscription }                    from 'rxjs';
import { takeUntil }                       from 'rxjs/operators';

@Component( {
	selector: 'app-entity-active-sort-property[config][entity]',
	templateUrl: './entity-active-sort-property.component.html',
	styleUrls: [ './entity-active-sort-property.component.scss' ]
} )
export class EntityActiveSortPropertyComponent extends BaseComponent implements OnInit {

	private _subscription: Subscription;
	private _listOperationsId: ListOperationsIdentifierEnum;
	private _showableSortPropKeys: string[];
	private _dateTimeFormatOptions: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
	private activeSortKey: string;
	public activeSortPropertyValue: string;

	@Input() set config( config: IEntityActiveSortPropertyConfig ) {
		this.entity = config?.entity ?? null;
		this._dateTimeFormatOptions = config?.dateFormat ?? null;
		this.listOperationsId = config?.listOperationsId ?? null;
		this._showableSortPropKeys = config?.showableSortPropKeys ?? [];

		this.subscribeToStoredListOperation();
	}


	@Input() set dateFormat( dateFormat: Intl.DateTimeFormatOptions ) {
		this._dateTimeFormatOptions = dateFormat ?? null;
	}

	@Input() set showableSortPropKeys( showableSortPropKeys: string[] ) {
		this._showableSortPropKeys = showableSortPropKeys ?? [];
	}

	@Input() set listOperationsId( listOperationsId: ListOperationsIdentifierEnum ) {
		this._listOperationsId = listOperationsId;
		this.subscribeToStoredListOperation();
	}

	@Input() entity: any;

	constructor(
		public readonly listOperationsService: ListOperationsService
	) {
		super();
	}

	private setActiveSortPropertyValue(): void {
		const entityPropertyValue: any = this.entity ? this.entity[ this.activeSortKey ] : null;

		if ( entityPropertyValue === null || entityPropertyValue === undefined ) {
			this.activeSortPropertyValue = null;
			return;
		}

		// string values
		if ( typeof entityPropertyValue === 'string' ) {
			this.activeSortPropertyValue = entityPropertyValue;
			return;
		}

		// date values
		if ( entityPropertyValue instanceof Date ) {
			this.activeSortPropertyValue = this._dateTimeFormatOptions
																		 ? this.getLocaleDateString( entityPropertyValue, this._dateTimeFormatOptions )
																		 : null;
			return;
		}

		// not supported types
		this.activeSortPropertyValue = null;
	}

	private subscribeToStoredListOperation(): void {
		if ( this._subscription ) {
			this._subscription.unsubscribe();
		}

		this._subscription = this.listOperationsService.select.listOperationsById(
			this._listOperationsId,
			'EntityActiveSortPropertyComponent:subscribeToStoredListOperation'
		)
		.pipe( takeUntil( this.ngUnsubscribe ) )
		.subscribe( ( listOperation: ListOperations ) => {
			const sortKey = listOperation?.sort?.split( ',' )[ 0 ];
			this.activeSortKey = this._showableSortPropKeys?.find( ( allowedProp: string ) => allowedProp === sortKey );
			this.setActiveSortPropertyValue();
		} );
	}

	ngOnInit(): void {
		this.subscribeToStoredListOperation();
	}
}
